import React from "react";
import { Button } from "@chakra-ui/react";

const VARIANT_STYLES = {
  primary: { variant: "solid", colorScheme: "gwbi" },
  secondary: { variant: "outline", colorScheme: "gwbi" },
  ghost: { variant: "ghost" },
  subtle: {
    variant: "solid",
    bg: "surface.subtle",
    color: "text.muted",
    _hover: { bg: "surface.muted" },
  },
  link: { variant: "link", colorScheme: "gwbi" },
};

export default function UiButton({ variant = "primary", ...props }) {
  if (!VARIANT_STYLES[variant]) {
    return <Button variant={variant} {...props} />;
  }

  const styleProps = VARIANT_STYLES[variant];
  return <Button {...styleProps} {...props} />;
}
